import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import * as serviceWorker from 'serviceWorker'
import App from 'pages/App'
import React from 'react'
import 'const/fontawesomeLibrary'
import { Provider } from 'react-redux'
import Store from 'redux/store'
import { history } from 'ui/customHooks/useHistory'
import { Router } from 'react-router-dom'
import config from 'const/config'
import { initAppOverrides } from 'helpers/appOverrides'

if (process.env.NODE_ENV !== 'production') {
  import('react-axe').then(({ default: axe }) => {
    axe(React, ReactDOM, 1000)
  })
}

if (config.ALLOW_OVERRIDES === 'yes') {
  initAppOverrides()
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
)

serviceWorker.unregister()
